import { Modal, Skeleton } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import FastAddIcon from "assets/icons/FastAddIcon";
import PlusIcon from "assets/icons/PlusIcon";
import SearchIcon from "assets/icons/SearchIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import Portal from "components/Portal";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicSelect from "components/BasicInputs/BasicSelect";
import ModalBox from "components/Shared/Modals/ModalBox";
import { useEffect, useState } from "react";
import productImage from "assets/images/product-bg.png";
import HashtagIcon from "assets/icons/Hashtag";
import useCurrency from "helpers/useCurrency";
import BasicCondInput from "components/BasicInputs/BasicCondInput";
import { search } from "helpers";
import ContainedTabs from "components/Tabs/Tabs3";
import { apiGetProductCategories } from "api/categoryApi";
import { store } from "store/store";
import { apiGetProductList } from "api/productApi";

export interface MultiSelectProps {
  onChange?: (rows?: MultiSelectRow[]) => void;
  activeTab?: string
}
export interface MultiSelectRow {
  count: number;
  unit: string;
  product: Product;
  id: number;
}
export default function MultiSelect(props: MultiSelectProps) {
  const { activeTab } = props
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [category, setCategory] = useState(null);
  const { defCur } = useCurrency();
  const [categories, setCategories] = useState<any[]>([]);
  const [rows, setRows] = useState<MultiSelectRow[]>();
  const [products, setProduct] = useState<Product[]>();
  const dispatch = store.dispatch
  const token = store.getState().businessReducer.business.token
  const [active, setActive] = useState(0)
  //@ts-ignore
  const prods = search(text, products, category?.id ?? null);
  const t = rows?.map((x) => x.count);
  const totalCount = t?.length ? t.reduce((a, b) => a + b) : 0;
  const getProduct = () => {
    setProduct([])
    dispatch(apiGetProductList({
      token, key: active === 0 ? "product" : "service", type: activeTab, callBack: (res: any) => {
        setProduct(res)
      }
    }))
  }
  useEffect(() => {
    if (open && !products?.length)
      getProduct()

    return () => {

    }
  }, [open])
  useEffect(() => {
    if (open)
      getProduct()

    return () => {

    }
  }, [active])

  return (
    <div>
      <BasicButton variant="text" color="primary" onClick={() => setOpen(true)}>
        <FastAddIcon />
        <span>افزودن سریع کالا</span>
      </BasicButton>
      <Portal>
        <Modal open={open}>
          <ModalBox
            title="افزودن کالا/خدمات"
            onClose={() => setOpen(false)}
            style={{ body: { padding: 0 } }}
            footer={
              <div className="w-full flex justify-end items-center gap-4 px-4">
                <BasicButton variant="outlined" color="disabled" onClick={() => setRows(undefined)}>
                  <span>پاک کردن همه</span>
                </BasicButton>
                <BasicButton variant="outlined" onClick={() => setOpen(false)}>
                  <span>لغو</span>
                </BasicButton>
                <BasicButton
                  variant="contained"
                  onClick={() => {
                    setOpen(false);
                    props.onChange && props.onChange(rows);
                    setRows([])
                  }}
                >
                  <span>افزودن {totalCount} کالا</span>
                </BasicButton>
              </div>
            }
          >
            <div className="flex flex-col">
              <div className="p-6 border-b-2 border-gray-300">
                <BasicTextInput
                  suffix={<SearchIcon color="#B6B7B8" />}
                  placeHolder="جستجو"
                  onChange={(val) => setText(`${val}`)}
                />
              </div>
              <div className="flex items-center gap-4 p-6 border-b-2 border-gray-300 justify-between">
                <div className="flex items-center gap-4 p-6 border-b-2 border-gray-300 justify-between ">

                  <ContainedTabs
                    tabs={[
                      { label: "محصول", activeColor: "#1062D0" },
                      { label: "خدمات", activeColor: "#CB0B0B" },
                    ]}
                    centered={true}
                    onChange={(val) => {
                      val !== undefined && setActive(val)
                    }}
                    size={3}
                    minWidth={46}
                  />
                  <ChevronIcon rotate="left" />
                  <BasicSelect
                    preferences={{ button: 2 }}
                    withRefresh
                    withClear
                    refreshList={() => {
                      setCategories([])
                      return dispatch(apiGetProductCategories(token, active === 0, (res: any) => {
                        setCategories(res)

                      }))
                    }}
                    options={{
                      //@ts-ignore
                      title: "دسته بندی ها",
                      id: "main",
                      childs: categories.map((x) => ({ ...x, parentId: "main" })),
                    }}
                    isNested
                    //@ts-ignore
                    placeholder={category?.title ?? "انتخاب دسته بندی"}
                    onChange={(id, value) => {
                      setCategory(value)
                    }}
                  />
                </div>
                <BasicButton variant="outlined" color="disabled" onClick={() => { setCategory(null); setText("") }}>
                  <span> پاک کردن فیلتر ها </span>
                </BasicButton>
              </div>
              <div>

                {

                  //@ts-ignore
                  prods.length ? prods?.map((product, i, arr) => {
                    const row = rows?.find((x) => x.id === product.id);

                    const image = product.imageUrl || productImage;
                    let conditions: any = [
                      { label: product.unit, title: product.unit, value: product.unit, type: "number-native" },
                    ];
                    if (product.subUnit) {
                      conditions = [
                        ...conditions,
                        {
                          label: product.subUnit,
                          title: product.subUnit,
                          value: product.subUnit,
                          type: "number-native",
                        },
                      ];
                    }
                    return (
                      <div
                        key={i}
                        className="flex justify-between items-center p-6 cursor-pointer hover:bg-gray-50"
                      >
                        <div className="flex gap-4">
                          <div className="flex flex-col items-center justify-between gap-2">
                            <div className="flex w-full justify-center items-center">
                              <div
                                className={`rounded-full overflow-hidden border border-slate-400 bg-center bg-cover bg-no-repeat`}
                                onClick={() => product.imageUrl && window.open(product.imageUrl, "_blank")}
                                style={{
                                  backgroundImage: `url("${image}")`,
                                  minHeight: 52,
                                  minWidth: 52,
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex flex-col gap-1 justify-center w-full overflow-hidden">
                            <div className="flex gap-1 items-center">
                              <span style={{ fontSize: 16 }} className="text-dark-6">
                                {product.accountingCode}
                              </span>
                              <span
                                className="bg-slate-100 rounded w-4 h-4 flex justify-center items-center"
                                style={{ fontSize: 14 }}
                              >
                                <HashtagIcon color="#7E8C9E" style={{ transform: "scale(0.8)" }} />
                              </span>
                              <span style={{ fontSize: 13 }} className="text-dark-6 whitespace-normal">
                                {product.title}
                              </span>
                              <span className="text-sm text-slate-400">{product.barcodes?.join(", ")}</span>
                            </div>
                            <div className="flex gap-4 items-center">
                              <span className="text-xs">آخرین قیمت</span>
                              <div className="flex items-center gap-1">
                                <span className="text-xs text-red-500">فروش:</span>
                                <div className="flex gap-1 items-center">
                                  <span className="text-gray-400 text-xs">{defCur.en_title}</span>
                                  <span className="text-sm">
                                    {Intl.NumberFormat().format(
                                      product.lastSellPrice || product.sellPrice || 0
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="flex items-center gap-1">
                                <span className="text-xs text-green-500">خرید:</span>
                                <div className="flex gap-1 items-center">
                                  <span className="text-gray-400 text-xs">{defCur.en_title}</span>
                                  <span className="text-sm">
                                    {Intl.NumberFormat().format(product.lastBuyPrice || product.buyPrice || 0)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="flex items-center gap-4  justify-between">
                          {/* 
                          <span className="text-xs">موجودی:</span>
                          <span
                            className={`text-xs ${product.productCount && product.productCount < 0
                              ? "text-red-500"
                              : "text-blue-1"
                              }`}
                          >
                            {Math.abs(product.productCount || 0)} {product.unit}
                          </span> */}
                          {!row?.count ? (
                            <>

                              <BasicButton
                                variant="outlined"
                                className="min-w-[32px] min-h-[32px] flex justify-center items-center p-0"
                                onClick={() =>
                                  setRows((x) =>
                                    row
                                      ? x?.map((y) => (row.id === product.id ? { ...y, count: 1 } : y))
                                      : [
                                        ...(rows || []),
                                        { count: 1, unit: product.unit, product, id: product.id },
                                      ]
                                  )
                                }
                              >
                                <PlusIcon scale={0.7} />
                              </BasicButton>
                            </>
                          ) : (
                            <BasicCondInput
                              // conditions={conditions}
                              styles={{ width: '150px' }}
                              cond={{ label: "+", title: "+", value: '', type: "number" }}
                              val={row.count}
                              onchange={(val) => {
                                setRows(
                                  rows?.flatMap((row) =>
                                    row.id === product.id
                                      ? val.val
                                        ? { ...row, quantity: val.val, count: val.val, unit: val.cond.value }
                                        : []
                                      : row
                                  )
                                );
                              }}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })
                    : <Skeleton variant="rectangular" className="h-[470px]" />
                }
              </div>
            </div>
          </ModalBox>
        </Modal>
      </Portal>
    </div>
  );
}
